import { ParsedUrlQuery } from 'querystring';

export function getChainFree(query: ParsedUrlQuery) {
    if (query['chain_free']) {
        return query['chain_free'];
    }

    return '';
}
